<app-status-badge
  [colourScheme]="statusBadgeColourSchemeEnum"
  name="public-commenting-status"
>
  {{ statusText }}
</app-status-badge>
